

export const CONJOINT_VALUE = '1'
export const CONCUBIN_VALUE = '3'
export const PACSES_VALUE = '7'
export const ENFANT_MINEUR = '2_A'
export const ENFANT_MAJEUR = '2_B'

export const BENEFICIARY_TYPES = [
    {
        value: ENFANT_MINEUR,
        label: 'Enfant mineur',
        document: 'Acte de naissance ou copie du livret de famille'
    },
    {
        value: ENFANT_MAJEUR,
        label: 'Enfant majeur',
        document: 'Certificat de scolarité'
    },
    {
        value: CONJOINT_VALUE,
        label: 'Conjoint',
        document: 'Acte de mariage ou copie du livret de famille'
    },
    {
        value: CONCUBIN_VALUE,
        label: 'Concubin',
        document: 'Attestation de concubinage ou Justificatif de vie commune (quittance de loyer, compte bancaire joint...) ou Attestation sur l\'honneur de vie maritale'
    },
    {
        value: PACSES_VALUE,
        label: 'Pacsé',
        document: 'Copie du PACS'
    }
]

export const BENEFICIARY_TYPES_WITHOUT_CONCUBIN = [
    {
        value: '2_A',
        label: 'Enfant mineur',
        document: 'Acte de naissance ou copie du livret de famille'
    },
    {
        value: '2_B',
        label: 'Enfant majeur',
        document: 'Certificat de scolarité'
    }
]
